var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nps-main"},[_c('h2',{staticClass:"question f-bold",domProps:{"innerHTML":_vm._s(_vm.question)}}),_c('NPS',{on:{"select":_vm.onSelectScore}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }